import projectsData from "../../../data/projects.json";
import ProjectsCard from "./projectsCard";

function Projects() {
    const projectsCards = projectsData.map(repository => <ProjectsCard key={repository.url} information={repository} />);

    return <section className="container section">
        <h3 className="is-size-3 mb-3">HPAI - Recent lines of projects</h3>
        <div className="is-multiline">
            {projectsCards}
        </div>
    </section>;
};

export default Projects;